import React from "react";
import BodyText from "./BodyText";
import "blocks/PageBlocks.scss";

const Article = ({ heading, copy, children, id }) => {
  return (
    <div className="article" id={id}>
      <h2>{heading}</h2>
      <BodyText body={copy} />
      {children}
    </div>
  );
};

export default Article;
